import { useHooks } from '@everlywell/leaves';
import React, { createContext } from 'react';
import { UseIsFeatureEnabledResult } from 'utils/hooks/useIsFeatureEnabled/useIsFeatureEnabled';
import { AllProductInfoType } from 'utils/types';

export type PurchaseOptionsDrawerProduct = Pick<
  AllProductInfoType,
  | 'name'
  | 'slug'
  | 'price'
  | 'variantId'
  | 'subscriptionVariants'
  | 'preSelectedSubscription'
  | 'hideSubscription'
  | 'productId'
  | 'promotionable'
>;

export type PurchaseOptionsOverlayContextValue = {
  product: PurchaseOptionsDrawerProduct | null;
  setProduct: (product: PurchaseOptionsDrawerProduct) => void;
  clearProduct: () => void;
};

// Create the context
export const PurchaseOptionsOverlayContext = createContext<
  PurchaseOptionsOverlayContextValue | undefined
>(undefined);

export const usePurchaseOptionsContext = () => {
  const value = React.useContext(PurchaseOptionsOverlayContext);

  if (value === undefined) {
    throw new Error(
      'useAvailablePurchaseOptions must be used within a PurchaseOptionsOverlayProvider',
    );
  }

  return value;
};

// Optional version that doesn't throw when provider is not available
export const useOptionalPurchaseOptionsContext = () => {
  const value = React.useContext(PurchaseOptionsOverlayContext);
  return value; // Returns undefined if not within provider, which is fine
};

export const useIsPurchaseOptionsEnabled = (): UseIsFeatureEnabledResult => {
  const { isMobile } = useHooks.useWindowSize();

  return isMobile
    ? { isEnabled: true, isLoading: false }
    : { isEnabled: false, isLoading: false };
};
